import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import FaqComponents from "../components/common/faq";

const faqs = [
  {
    question: "What is an enterprise app development company?",
    answer: `<p>An enterprise app development company is involved in the process of creating applications for enterprise-sized businesses, specifically customized to meet their business needs.Once finished, these applications can be rolled out on the required platforms and devices.</p>`,
  },
  {
    question: "How much does it cost to develop an enterprise app?",
    answer: `<p>The cost to develop an enterprise app is dependent on the complexity of the app.Simple apps with basic functionality, such as a calculator or flashlight app, can cost from $10,000 to $40,000 and more to develop.</p>
    <p>Applications with higher complexity, like social media or e-commerce apps, may have development costs ranging from $30,000 to $500,000 or beyond</p>
    <p>High-end applications with complex functionalities and enterprise-grade features, like a banking or healthcare app, may demand costs exceeding $500,000 and potentially reaching into the millions for the most advanced applications</p>`,
  },
  {
    question: "What are the 4 major applications for enterprise applications?",
    answer: `<p>The four main enterprise applications are enterprise systems, customer relationship management systems, knowledge management systems and supply chain management systems.</p>`,
  },
  {
    question: "Which language is used for enterprise application?",
    answer: `<p>Java stands out as the optimal programming language for building enterprise applications.</p>
    <p>Offering portability, scalability, a diverse ecosystem, security features, and community backing, Java furnishes developers with all the essential elements to develop robust and effective applications that cater to the requirements of sizable organizations.</p>`,
  },
  {
    question: "What are the benefits of enterprise mobile app development?",
    answer: `<p>The benefits of enterprise mobile app development include:</p>
    <ul>
    <li><strong>Increased Productivity:</strong> Enterprise mobile apps have the potential to enhance efficiency by granting employees immediate access to vital business information and functionalities, including email, project management tools, and customer relationship management systems.</li>
    <li><strong>Improved Communication:</strong> Enterprise mobile apps can enhance internal communication by offering employees instant messaging, video conferencing, and collaborative tools in real-time.</li>
    <li><strong>Streamlined Processes:</strong> Enterprise mobile apps have the capacity to simplify procedures by automating tasks, minimizing the necessity for manual data input, and eliminating paper-based processes.</li>
    <li><strong>Enhanced Customer Experience:</strong> Enterprise mobile apps can improve the customer experience by granting customers instant access to their account details, support materials, and self-service alternatives.</li>
    <li><strong>EIncreased Data Security:</strong> Enterprise mobile apps have the potential to boost data security by implementing authentication and authorization controls, encrypting data, and enforcing access controls. These measures contribute to safeguarding confidential business information.</li>
    </ul>`,
  },
  {
    question: "Will I be getting any support after project completion?",
    answer: `<p>Absolutely! We never leave our clients on their own after the project completion as there is a constant support and maintenance service that you can avail to maintain the sustainability of your application.</p>
    <p>Especially, when you deploy enterprise app development, there is always a need for support to further enhance and alter the features based on the increasing requirements of the audience. It will overcome any flaw that may arise after the application is live.</p>`,
  },
];

function FaqLocation(props) {
  return (
    <div className="faq_loc p-100 tekrevol_dark_bg">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="FAQs">
              <h2>Enterprise App Development FAQs</h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="services_faqs"
          >
            <FaqComponents faqs={faqs} />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
